import Cart from "./../models/cart.js";
import Checkout from "./../models/checkout.js";

class CbInitializer {

  static init() {
    var queryParams = this.fetchQueryParams();
    console.log("logging query params");
    console.log(queryParams);

    // Fetch site from query parameter
    var checkout = new Checkout(queryParams["site"]);    
    this.fetchAllConfigs(checkout.siteName).then((results) => {
      // Load config for fetched site
      checkout.load(results.slice(0,2));
      this.styleConfig = results[2] && results[2].data;
      console.log(CbInitializer.styleConfig);
    });

    // initialize cart details
    checkout.cart = new Cart(queryParams);
    console.log("logging checkout details");
    console.log(checkout);

    return checkout;
  }

  static fetchQueryParams() {
    var queryString = window.location.search.slice(1);
    return queryString.split("&").reduce((output,  pair) => {
      output[pair.split("=")[0]] = pair.split("=")[1];
      return output;
    }, {});
  }

  static fetchAllConfigs(siteName) {
    var promises = [];
    promises.push(axios.get("/json/" + siteName + "/config.json"));
    promises.push(axios.get("/json/" + siteName + "/product.json"));
    promises.push(axios.get("/json/" + siteName + "/style_config.json"));
    return axios.all(promises)
  }
}

export default CbInitializer;


// WEBPACK FOOTER //
// ./src/services/cb-initializer.js